

export const LoginType = {
  AUTHENTICATE: 'AUTHENTICATE',
  CHANGED_PASSWORD: 'CHANGED_PASSWORD'
};

export const ErrorType = {
  ERROR_LOG: 'ERROR_LOG'
};

export const UserType = {
  GET_USER: 'GET_USER',
  GET_ALL_USERS: 'GET_ALL_USERS',
  CREATE_USER: 'CREATE_USER',
  DELETE_USER: 'DELETE_USER',
  UPDATE_USER: 'UPDATE_USER',
  GET_BUSINESS: 'GET_BUSINESS',
  GET_BUSINESS_INFO: 'GET_BUSINESS_INFO',
  GET_ALL_DOCTORS: 'GET_ALL_DOCTORS',
  GET_TRANSLATION: 'GET_TRANSLATION',
  CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
  GET_NOTIFICATIONS: 'GET_NOTIFICATIONS',
  GET_MASTER_DRUG: 'GET_MASTER_DRUG'
};

export const RoleType = {
  GET_ROLES: 'GET_ROLES',
  ADD_ROLE: 'ADD_ROLE',
  UPDATE_ROLE: 'UPDATE_ROLE',
  DELETE_ROLE: 'DELETE_ROLE'
};


export const MasterDataType = {
  GET_MASTERDATA_SUPPLIER: 'GET_MASTERDATA_SUPPLIER',
  POST_MASTERDATA_SUPPLIER: 'POST_MASTERDATA_SUPPLIER',
  
};




// WEBPACK FOOTER //
// ./actions/ActionType.js